import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { PlantServiceService } from '../../../../../services/dashboard/solar/plant-service.service';
import { UtilitiesService} from 'src/app/services/index';
import {Subscription, timer, Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent, BehaviorSubject} from 'rxjs';
import { Chart } from 'angular-highcharts';
import { DatePipe, DecimalPipe } from '@angular/common';
import {Highcharts$} from 'src/app/shared/index';
import { delay, combineLatest } from 'rxjs/operators';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-performance-characteristic',
  templateUrl: './performance-characteristic.component.html',
  styleUrls: ['./performance-characteristic.component.scss']
})
export class PerformanceCharacteristicComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges  {
  //  @ViewChild('netACPowerChart') public chartEl: ElementRef;
 // tslint:disable-next-line:no-input-rename
  siteId: string;

  // tslint:disable-next-line:no-input-rename
//   @Input('total-installed-capacity') totalInstalledCapacity: any = null;

  colorRed = '#DF5353';
  colorGreen = '#55BF3B';
  colorYellow = '#DDDF0D';
  private chartACPowerHC: any;
  netACPowerHC: Chart;
  performanceRatioHC: Chart;
  performanceInterval: any;
  subscription: Subscription;
  acSubscription: Subscription;
  totalACPower: any;
  isFirstTime = true;
  isPerformanceFirstTime = true;
  private alive = true;
  iconPerformance = false;
  todayEnergy: any;
  todayPR = 0;
  constructor(private plantService: PlantServiceService, private utilitiesService: UtilitiesService,
    private decimalPipe: DecimalPipe,
    private cd: ChangeDetectorRef) {
      this.subscription = new Subscription();
      // this.netACPowerHC = new Chart();
      // this.performanceRatioHC = new Chart();
   }
  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      this.siteId = solarConfig.siteId;
      self.getLatestIrradianceDataOfSite();
      self.getLatestPerformanceRatioOnedayOfSite(solarConfig.siteId, solarConfig.totalInstalledCapacity);
      const acTimer = timer(30, 30 * 1000);
      self.subscription = acTimer.subscribe(() => {
        if (self.alive) {
          self.getLatestIrradianceDataOfSite();
          self.getLatestPerformanceRatioOnedayOfSite(solarConfig.siteId, solarConfig.totalInstalledCapacity);
        } else {
          if (self.subscription) {
            self.subscription.unsubscribe();
          }
        }
      });
    });
  }
  ngOnChanges() {
  }
  ngAfterViewInit() {
    this.cd.detectChanges();
    window.addEventListener('resize', this.resizeChart);
    // this.performanceRatioHC.ref$.subscribe((chartInstance: any)  => {
    //   const point = chartInstance.series[0].points[0];
    //   point.onMouseOver();
    //   chartInstance.tooltip.refresh(point); // Show the tooltip
    // });
    // this.netACPowerHC.ref$.subscribe((chartInstance: any)  => {
    //   const point = chartInstance.series[0].points[0];
    //   point.onMouseOver();
    //   chartInstance.tooltip.refresh(point); // Show the tooltip
    // });
  }
  private resizeChart = () => {
    this.onChartLoaded();
  }
  private getLatestPerformanceRatioOnedayOfSite = (siteId: string, totalInstalledCapacity: number) => {
    const self = this;
    this.plantService.getLatestPerformanceRatioOnedayOfSite(siteId, totalInstalledCapacity.toString())
    .subscribe(
      res => {
        if (!isNaN(res.performanceRatioOneday)) {
          const value = parseFloat(res.performanceRatioOneday);
          this.todayPR = value;
          if (self.isPerformanceFirstTime) {
            // self.initPerformanceRatioHC(value);
            self.initSolidGauge(this.todayPR);
          } else {
            self.performanceRatioHC.ref.series[0].points[0].update(this.todayPR);
            // self.onChartLoaded();
              // if (new Date().getTime() % 2) {
              //   self.performanceRatioHC.ref.series[0].points[0].update(20);
              // } else {
              //   self.performanceRatioHC.ref.series[0].points[0].update(80);
              // }
            // if (this.performanceRatioHC.ref !== undefined
            //   && this.performanceRatioHC.ref.series !== undefined
            //   && this.performanceRatioHC.ref.series[0].data) {
            //     this.performanceRatioHC.removePoint(this.performanceRatioHC.ref.series[0].data.length - 1);
            //   }
          }
          // this.performanceRatioHC.addPoint(value);
      } else {
                console.log(`Invalid Performance Ratio One day: ${res.performanceRatioOneday}`);
            }
      }
     );
  }
  private getLatestIrradianceDataOfSite = (): void => {
    const self = this;
    this.plantService.getTotalSolarEnergyYieldTrend(this.siteId).subscribe(
      data => {
        if (data.todayEnergy !== undefined) {
          let value = 0;
          if (data.todayEnergy !== '0') {
            value = parseFloat((data.todayEnergy));
          }
          this.todayEnergy = value;
          if (self.isFirstTime) {
            self.initSolidGauge(value, true);
          } else {
             self.netACPowerHC.ref.series[0].points[0].update(value);
             // self.onChartLoaded();
          }
        } else { // init defaul
          self.initSolidGauge(0, true);
          this.todayEnergy = 'NA';
        }
      }
     );
}
ngOnDestroy() {
  const t = this;
    if (t.subscription) {
      t.alive = false;
      t.subscription.unsubscribe();
    }
}
transformNumber(value: any): string {
return this.decimalPipe.transform(value, '1.0-2');
}
initNetACPowerHCChart(value: number, totalInstalledCapacity?: number) {
    // if (totalInstalledCapacity !== undefined) {
    //     totalInstalledCapacity = Math.round(totalInstalledCapacity);
    // }
    this.isFirstTime = false;
    const netACPowerUnit = 'MW';
    const option = {
        chart: {
          type: 'gauge',
          height: 200,
        },
        title: {
          text: ''
        },
        credits: {
            enabled: false
        },
        exporting: {
          enabled: false,
        },
        pane: {
            // center: ['50%', '60%'],
            size: '95%',
             startAngle: -160,
             endAngle: 160
        },
      // the value axis
      yAxis: {
         min: 0,
        max: (totalInstalledCapacity / 1000) * 1,
        // labels: {
        //     step: 2,
        //     rotation: 'auto'
        // },
        title: {
            text: netACPowerUnit
        },
        plotBands: [{
            from: 0,
            to: (totalInstalledCapacity / 1000) * 0.5,
            color: this.colorRed
        }, {
            from: (totalInstalledCapacity / 1000) * 0.5,
            to: (totalInstalledCapacity / 1000) * 0.75,
            color: this.colorYellow
        }, {
            from: (totalInstalledCapacity / 1000) * 0.75,
            to: (totalInstalledCapacity / 1000) * 1,
            color: this.colorGreen
        }]
    },
      series: [{
          name: ' ' + 'AC Power',
          data: [value],
          tooltip: {
              valueSuffix: ' ' + netACPowerUnit,
          }
      }]
    };
    this.netACPowerHC = new Chart(<any>option);
    //  this.netACPowerHC.init(this.chartEl);
    // this.chartACPowerHC = new Highcharts$.Chart('netACPowerChart', (<any>option));
    // if (this.chartEl && this.chartEl.nativeElement) {
    //   option.chart = {
    //     renderTo: this.chartEl.nativeElement
    //   };
    //   // this.netACPowerHC.init(this.chartEl);
    // }
     // Highcharts$.chart('netACPowerChart', <any>option);
}
initPerformanceRatioHC(dataChart?: any) {
  this.isPerformanceFirstTime = false;
    const performanceRatioUnit = '%';
    this.performanceRatioHC = new Chart(<any>{
        chart: {
          type: 'gauge',
          height: 200,
        },
        title: {
          text: ''
        },
        credits: {
            enabled: false
        },
        pane: {
           // center: ['50%', '60%'],
            size: '95%',
            startAngle: -160,
            endAngle: 160
        },
      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        // labels: {
        //     step: 2,
        //     rotation: 'auto'
        // },
        title: {
            text: performanceRatioUnit
        },
        plotBands: [{
            from: 0,
            to: 50,
            color: this.colorRed
        }, {
            from: 50,
            to: 75,
            color: this.colorYellow
        }, {
            from: 75,
            to: 100,
            color: this.colorGreen
        }]
    },
      series: [{
          name: ' ' + 'Today\'s Cumulative PR',
          data: [dataChart],
          tooltip: {
              valueSuffix: ' ' + performanceRatioUnit,
          }
      }]
    });

}
private onChartLoaded = () => {
  const self = this;
  setTimeout(function () {
    if (self.performanceRatioHC !== undefined && self.performanceRatioHC.ref) {
      const point = <any>self.performanceRatioHC.ref.series[0].points[0];
      point.onMouseOver();
      self.performanceRatioHC.ref.tooltip.refresh(point);
    }
    if (self.netACPowerHC !== undefined) {
      const pointEn = <any>self.netACPowerHC.ref.series[0].points[0];
      pointEn.onMouseOver();
      self.netACPowerHC.ref.tooltip.refresh(pointEn);
    }
  }, 200);
}
private initSolidGauge = (dataChart?: any, isEnergy = false) => {
  let textColor = '';
  let text = 'E';
  if (isEnergy) {
    textColor = (dataChart>75&&dataChart<=100)?this.colorGreen:(dataChart>=50&&dataChart<=75 ? this.colorYellow:this.colorRed);
    text = 'E';
  } else {
    textColor = (dataChart>75&&dataChart<=100)?this.colorGreen:(dataChart>=50&&dataChart<=75 ? this.colorYellow:this.colorRed);
    text = 'PR';
  }
  const options = {
    chart: {
      type: 'solidgauge',
      // height: 83,
      height: (2 / 3 * 100) + '%', // 16:9 ratio
      events: {
        load: this.onChartLoaded
      }
    },
    title: {
      text: '',
      style: {
          fontSize: '12px'
      }
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false
    },
    tooltip: {
      alwaysVisible: true,
      borderWidth: 0,
      backgroundColor: 'none',
      shadow: false,
      style: {
          fontSize: '14px'
      },
      // valueSuffix: '%',
      // pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}%</span>',
      pointFormat: `<span style="font-size:15px; color: ${textColor}; font-weight: bold">${text}</span>`,
      positioner: function (labelWidth, labelHeight) {
          return {
            x: (this.chart.chartWidth - labelWidth) / 2,
            y: (this.chart.plotHeight / 2) - 5
          };
      }
  },
    // tooltip: {
    //   borderWidth: 0,
    //   backgroundColor: 'none',
    //   shadow: false,
    //   style: {
    //       fontSize: '16px'
    //   },
    //   valueSuffix: '%',
    //   pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
    //   positioner: function (labelWidth) {
    //       return {
    //           x: (this.chart.chartWidth - labelWidth) / 2,
    //           y: (this.chart.plotHeight / 2) + 15
    //       };
    //   }
    // },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [ { // Track for Stand
          // outerRadius: '62%',
          // innerRadius: '38%',
          innerRadius: '100%',
          backgroundColor: '#f0f5f8',
          borderWidth: 0
      }]
  },
  yAxis: {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickPositions: []
  },
  plotOptions: {
    solidgauge: {
        dataLabels: {
            enabled: false
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true
    }
  },
  series: [{
    name: isEnergy === true ? 'E' : 'PR',
    data: [{
        color: (dataChart>75&&dataChart<=100)?this.colorGreen:(dataChart>=50&&dataChart<=75 ? this.colorYellow:this.colorRed),
        radius: '100%',
        innerRadius: '90%',
        y: dataChart
    }]
  }]
  };
  // this.utilitiesService.enableDraggingHighChart();
  if (isEnergy) {
      this.alwaysVisibleTooltip();
      this.netACPowerHC = new Chart(<any>options);
  } else {
    this.alwaysVisibleTooltip();
    this.performanceRatioHC = new Chart(<any>options);
  }
  //
}
private alwaysVisibleTooltip = () => {
   // tslint:disable-next-line:no-shadowed-variable
   Highcharts$.wrap(Highcharts$.Tooltip.prototype, 'hide', function (p, delay) {
    if (this.options.alwaysVisible) {
      return this.refresh(this.chart.series[0].data[0]);
    }
    p.call(this, delay);
  });
}
public click = () => {
  this.iconPerformance = !this.iconPerformance;
}
}
